/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_EyebrowInputs */

const en_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Coach`)
};

const es_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El entrenador`)
};

const de_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Trainer`)
};

const zh_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教练`)
};

const ar_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدرب`)
};

const fr_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'entraîneur`)
};

const vi_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên`)
};

const sw_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kocha huyo`)
};

const th_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โค้ช`)
};

const bs_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

const ja_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチ`)
};

const ko_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코치`)
};

const pt_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Treinador`)
};

const it_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach`)
};

const sv_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coachen`)
};

const nl_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Coach`)
};

const da_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træneren`)
};

const nb_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coachen`)
};

const fi_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmentaja`)
};

const pl_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

const ru_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренер`)
};

const tr_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenör`)
};

const hi_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोच`)
};

const id_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatih`)
};

const ms_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih`)
};

const cs_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenér`)
};

const el_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο προπονητής.`)
};

const he_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המאמן`)
};

const af_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die afrigter`)
};

const hu_about_eyebrow = /** @type {(inputs: About_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az edző.`)
};

/**
* | output |
* | --- |
* | "The Coach" |
*
* @param {About_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_eyebrow = /** @type {((inputs?: About_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_eyebrow(inputs)
	if (locale === "de") return de_about_eyebrow(inputs)
	if (locale === "zh") return zh_about_eyebrow(inputs)
	if (locale === "ar") return ar_about_eyebrow(inputs)
	if (locale === "fr") return fr_about_eyebrow(inputs)
	if (locale === "vi") return vi_about_eyebrow(inputs)
	if (locale === "sw") return sw_about_eyebrow(inputs)
	if (locale === "th") return th_about_eyebrow(inputs)
	if (locale === "bs") return bs_about_eyebrow(inputs)
	if (locale === "ja") return ja_about_eyebrow(inputs)
	if (locale === "ko") return ko_about_eyebrow(inputs)
	if (locale === "pt") return pt_about_eyebrow(inputs)
	if (locale === "it") return it_about_eyebrow(inputs)
	if (locale === "sv") return sv_about_eyebrow(inputs)
	if (locale === "nl") return nl_about_eyebrow(inputs)
	if (locale === "da") return da_about_eyebrow(inputs)
	if (locale === "nb") return nb_about_eyebrow(inputs)
	if (locale === "fi") return fi_about_eyebrow(inputs)
	if (locale === "pl") return pl_about_eyebrow(inputs)
	if (locale === "ru") return ru_about_eyebrow(inputs)
	if (locale === "tr") return tr_about_eyebrow(inputs)
	if (locale === "hi") return hi_about_eyebrow(inputs)
	if (locale === "id") return id_about_eyebrow(inputs)
	if (locale === "ms") return ms_about_eyebrow(inputs)
	if (locale === "cs") return cs_about_eyebrow(inputs)
	if (locale === "el") return el_about_eyebrow(inputs)
	if (locale === "he") return he_about_eyebrow(inputs)
	if (locale === "af") return af_about_eyebrow(inputs)
	if (locale === "hu") return hu_about_eyebrow(inputs)
	return en_about_eyebrow(inputs)
});